import Api from '@/api'
import {locales, defaultLocale} from './locales'
import i18n from '../../i18n'

export default {
  state: {
    locales: locales,
    active: defaultLocale,
    tr_list: [],
    UiTranslateLoaded: false,
    localesListLoaded: false
  },
  actions: {
    async LOAD_UI_TRANSLATE({commit}, lang) {
      try {
        const res = await Api.load_ui_messages(lang)
        const {status} = res
        if (status === 200 && res.data) {
          const messMixin = {...i18n.messages[lang]}
          Object.keys(res.data).forEach((elem) => {
            if (!messMixin.hasOwnProperty(elem)) {
              messMixin[elem] = {}
            }
            Object.keys(res.data[elem]).map((item) => {
              const val = res.data[elem][item]
              messMixin[elem] = {...messMixin[elem], [item]: val}
            })
          })
          i18n.setLocaleMessage(lang, messMixin)
          commit('SET_UI_TRANSLATE_LOAD_STATE', true)
        } else {
          throw 'no Data'
        }
      } catch (err) {
        console.log(err)
      }
    },
    async LOAD_LOGIN_TRANSLATE({commit}, lang) {
      try {
        const res = await Api.load_login_messages(lang)
        const {status} = res
        if (status === 200 && res.data) {
          const messMixin = {...i18n.messages[lang]}
          Object.keys(res.data).forEach((elem) => {
            if (!messMixin.hasOwnProperty(elem)) {
              messMixin[elem] = {}
            }
            Object.keys(res.data[elem]).map((item) => {
              const val = res.data[elem][item]
              messMixin[elem] = {...messMixin[elem], [item]: val}
            })
          })
          i18n.setLocaleMessage(lang, messMixin)
        } else {
          throw 'no Data'
        }
      } catch (err) {
        console.log(err)
      }
    },
    async LOAD_LOCALES_LIST({state, commit}) {
      try {
        const res = await Api.load_locales_list()
        const {status} = res
        if (status === 200 && res.data) {
          commit('SET_LOCALES_LIST', res.data)
          if (!state.active) {
            const firsLang = state.locales.find((locale) => locale.index === 0)
            commit('CHANGE_LANG', firsLang.code)
          }
        } else {
          throw 'no Data'
        }
      } catch (err) {}
    },
    async LOAD_TRANSLATION_LIST({commit}) {
      try {
        const res = await Api.load_translate_list()
        const {status} = res
        if (status === 200 && res.data) {
          commit('SET_TRANSLATION_LIST', res.data)
        } else {
          throw 'no Data'
        }
      } catch (err) {
        console.log(err)
      }
    },

    async UPD_TRANSLATE_ENTRY({commit}, payload) {
      const {id, item} = payload
      try {
        const res = await Api.upd_translate_entry(id, item)
        const {status} = res
        if (status === 200) {
          commit('UPDATE_TRANSLATE_ITEM', item)
        } else {
          throw 'no Data'
        }
      } catch (err) {
        throw err.response ? `${err.response.data.message}` : err
      }
    },
    async ADD_TRANSLATE_ENTRY({commit}, item) {
      try {
        const res = await Api.add_translate_entry(item)
        const {status} = res
        if (status === 201 && res.data) {
          commit('ADD_TRANSLATE_ITEM', res.data)
        } else {
          throw 'no Data'
        }
      } catch (err) {
        throw err.response ? `${err.response.data.message}` : err
      }
    }
  },
  mutations: {
    SET_UI_TRANSLATE_LOAD_STATE(state, status) {
      state.UiTranslateLoaded = status
    },
    INIT_LANG: (state) => {
      state.locales = [...locales]
      //state.active = defaultLocale
      i18n.locale = state.active
    },
    CHANGE_LANG(state, code) {
      state.active = code
      localStorage.setItem('rms-locale', code)
      i18n.locale = state.active
    },
    SET_TRANSLATION_LIST(state, list) {
      state.tr_list = list
    },
    SET_LOCALES_LIST(state, list) {
      Object.keys(list).forEach((item, index) => {
        const existLocaleId = state.locales.findIndex(
          (locale) => locale.code === item
        )
        if (~existLocaleId) {
          state.locales[existLocaleId].name = list[item]
          state.locales[existLocaleId].index = index
        } else {
          state.locales.push({code: item, name: list[item], index: index})
        }
      })
      state.localesListLoaded = true
    },
    UPDATE_TRANSLATE_ITEM(state, item) {
      const {category, key, ...langs} = item

      const ind = state.tr_list.findIndex((item) => {
        return item.category === category && item.key === key
      })
      if (ind > -1) {
        Object.keys(langs).forEach((lang) => {
          state.tr_list[ind][lang] = langs[lang]
        })
      }
    },
    ADD_TRANSLATE_ITEM(state, item) {
      state.tr_list.push(item)
    }
  },
  getters: {
    isUiTranslateLoaded: (state) => state.UiTranslateLoaded,
    locale_active: (state) => state.active,
    isLangMessagesExist: (state) => (code) => {
      return Boolean(i18n.messages[code] && i18n.messages[code]['menu'])
    },
    isLangLoginMessagesExist: (state) => (code) => {
      return Boolean(i18n.messages[code] && i18n.messages[code]['login'])
    },
    localesListLoaded: (state) => state.localesListLoaded
  }
}
